import { Box, Paragraph, TextButton } from '@zillow/constellation-10';
import { useFieldArray } from 'react-hook-form';
import { MAX_PERSONAL_REFERENCES } from '../../../../../constants/form';
import type { Contact } from '../../../../../models/rental-application';
import { ContactCard } from './ContactCard';

const emptyReference: Contact = {
  name: '',
  relationship: '',
  email: '',
  phone: '',
  notes: '',
  businessAddress: null,
};

export function PersonalReferencesSection() {
  const { fields, append, remove } = useFieldArray({ name: 'personalReferences' });

  return (
    <>
      <Paragraph textStyle="body-sm" css={{ marginBottom: 'default' }}>
        Choose people who know you well — a coworker, teacher, or neighbor works great. Skip family members and your
        current landlord.
      </Paragraph>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default' }}>
        {fields.map((reference, index) => (
          <ContactCard
            key={reference.id}
            fieldName={`personalReferences[${index}]`}
            title={`Reference #${index + 1}`}
            hasRelationship
            hasNotes
            onDelete={() => remove(index)}
          />
        ))}
        {fields.length < MAX_PERSONAL_REFERENCES && (
          <TextButton onClick={() => append(emptyReference)} type="button" css={{ marginTop: 'tighter' }}>
            Add reference
          </TextButton>
        )}
      </Box>
    </>
  );
}
